// extracted by mini-css-extract-plugin
export default {"how-to-use-template":"HowToUseTemplate_how-to-use-template__gYzMD"};